const theme = {
  breakpoints: ['660px'],
  colors: {
    translucentWhite: 'rgba(252,252,252,0.85)',
    white: '#fcfcfc',
    black: '#202123',
    palePurple: '#9198c1',
    purple: '#62688e',
    navy: '#3f4b96'
  },
  fonts: {
    splash: {
      family: 'Roboto'
    },
    primary: {
      family: 'Montserrat',
      weight: 'normal'
    },
    header: {
      family: 'Satisfy'
    }
  }
}

export default theme



// WEBPACK FOOTER //
// ./src/theme.js